import React, { useContext, useEffect } from "react";
import { IconMinus, IconPlus2 } from "../../../base/icons/svg";
import { ExcalidrawWrapperContext } from "../WhiteboardCustomUI";
import '../styles/zoom-actions.css';
export default function ZoomActions({ excalidrawApi }) {
    const excalidrawWrapper = useContext(ExcalidrawWrapperContext);
    useEffect(() => {
        window.addEventListener('wheel', excalidrawWrapper.notifyZoom);
        return () => {
            window.removeEventListener('wheel', excalidrawWrapper.notifyZoom);
        };
    }, []);
    const performCenteredZoom = async (zoomDelta) => {
        const currentAppState = excalidrawApi.getAppState();
        console.log("[ZoomActions Debug] currentAppState:", JSON.stringify(currentAppState, null, 2));
        const currentZoom = currentAppState.zoom.value;
        let newZoom = currentZoom + zoomDelta;
        // Apply zoom limits
        if (newZoom > 30)
            newZoom = 30;
        if (newZoom < 0.1)
            newZoom = 0.1;
        newZoom = Number(newZoom.toFixed(2));
        // Obtener dimensiones del viewport desde la API (no del wrapper externo)
        const width = currentAppState.width;
        const height = currentAppState.height;
        // Centro de la vista actual en coordenadas de pantalla
        const centerScreenX = width / 2;
        const centerScreenY = height / 2;
        // Convertir a coordenadas de escena (lo que el usuario ve en el centro)
        const sceneCenterX = (centerScreenX - currentAppState.scrollX) / currentZoom;
        const sceneCenterY = (centerScreenY - currentAppState.scrollY) / currentZoom;
        // Calcular nuevo scroll para mantener el mismo centro de escena
        const newScrollX = centerScreenX - sceneCenterX * newZoom;
        const newScrollY = centerScreenY - sceneCenterY * newZoom;
        await excalidrawApi.updateScene({
            appState: {
                zoom: { value: newZoom },
                scrollX: newScrollX,
                scrollY: newScrollY
            }
        });
        const nextAppState = excalidrawApi.getAppState();
        console.log('[ZoomActions Debug] after', JSON.stringify(nextAppState, null, 2));
        excalidrawWrapper.notifyZoom();
    };
    const resetZoom = () => {
        excalidrawApi.updateScene({
            appState: {
                zoom: { value: 1 },
                scrollX: 0,
                scrollY: 0
            }
        });
        excalidrawWrapper.notifyZoom();
    };
    return (React.createElement("div", { className: "whiteboard-custom-ui zoom-actions" },
        React.createElement("button", { className: "zoom-in-out-button", onClick: () => performCenteredZoom(0.1) },
            React.createElement(IconPlus2, null)),
        React.createElement("button", { className: "zoom-middle-button", onClick: resetZoom }, `${Math.round(excalidrawWrapper.zoom * 100)}%`),
        React.createElement("button", { className: "zoom-in-out-button", onClick: () => performCenteredZoom(-0.1) },
            React.createElement(IconMinus, null))));
}
